var _rect, _path, _path2, _path3, _g, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 260,
    viewBox: "0 0 1200 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2121_2977)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "#CBF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M557.356 188.413C560.643 166.567 581.017 151.523 602.863 154.81L1019.92 217.565C1041.76 220.852 1056.81 241.226 1053.52 263.071L990.766 680.126C987.479 701.972 967.105 717.016 945.259 713.729L528.205 650.974C506.359 647.687 491.315 627.313 494.602 605.468L557.356 188.413Z",
    fill: "url(#paint0_linear_2121_2977)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.147 334.218C222.247 334.178 220.409 335.229 219.533 337.054C218.992 338.181 218.546 339.145 218.211 339.93C217.928 340.591 217.557 341.502 217.384 342.354C217.333 342.6 217.266 342.997 217.26 343.475C217.255 343.871 217.279 344.839 217.814 345.9C218.488 347.24 219.8 348.346 221.524 348.631C222.888 348.857 223.95 348.469 224.367 348.296C225.229 347.937 225.844 347.406 226.045 347.233L226.046 347.233C226.351 346.97 226.638 346.685 226.884 346.429C227.986 345.285 229.866 343.004 232.314 340.034C233.67 338.388 235.202 336.53 236.872 334.537C246.574 322.955 262.476 304.892 283.243 287.446C324.931 252.427 385.056 220.801 453.593 247.049C465.248 251.513 482.086 260.791 501.445 272.657C520.718 284.47 542.203 298.667 563.056 312.793C578.256 323.09 593.086 333.324 606.465 342.556C611.442 345.991 616.219 349.288 620.739 352.397C637.298 363.788 650.604 372.804 657.509 376.733C693.33 397.118 723.246 393.864 745.892 382.514C768.2 371.333 783.019 352.54 789.741 342.324C791.673 339.387 794.03 334.15 796.686 327.727C799.28 321.454 802.334 313.605 805.778 304.754L806.271 303.488C813.583 284.7 822.669 261.435 833.138 238.238C843.619 215.014 855.403 192.047 868.058 173.821C880.856 155.391 893.937 142.713 906.71 138.679C920.271 134.397 936.087 133.917 953.398 134.992C963.374 135.611 973.355 136.695 983.547 137.802C991.352 138.65 999.281 139.511 1007.43 140.187C1043.87 143.213 1081.57 142.162 1108.57 113.762L1108.83 113.508C1109.04 113.299 1109.35 112.99 1109.76 112.586C1110.58 111.778 1111.77 110.591 1113.29 109.067C1116.33 106.019 1120.68 101.625 1125.9 96.227C1136.35 85.4352 1150.32 70.6137 1164.42 54.5162C1178.5 38.4364 1192.78 20.9964 1203.79 4.97985C1209.3 -3.02734 1214.05 -10.7633 1217.55 -17.8577C1221.02 -24.8781 1223.45 -31.619 1223.98 -37.556C1224.23 -40.3066 1222.19 -42.735 1219.44 -42.9802C1216.69 -43.2254 1214.26 -41.1945 1214.02 -38.444C1213.65 -34.3176 1211.85 -28.878 1208.59 -22.2873C1205.37 -15.7707 1200.9 -8.46496 1195.55 -0.68645C1184.86 14.8684 1170.86 31.976 1156.89 47.928C1142.94 63.8623 1129.09 78.5567 1118.72 89.2729C1113.53 94.6289 1109.23 98.9864 1106.21 102.002C1104.71 103.51 1103.53 104.683 1102.73 105.477C1102.49 105.707 1102.29 105.906 1102.12 106.071L1101.81 106.378L1101.58 106.606L1101.51 106.679C1101.51 106.68 1101.51 106.68 1105 110.254L1101.51 106.679L1101.44 106.745L1101.37 106.813C1077.87 131.594 1044.61 133.24 1008.26 130.221C1000.75 129.598 992.945 128.756 985.118 127.911C974.576 126.773 963.99 125.63 954.018 125.011C936.339 123.913 919.041 124.298 903.699 129.143C887.569 134.237 872.868 149.361 859.844 168.118C846.678 187.079 834.602 210.684 824.023 234.125C813.432 257.593 804.259 281.087 796.952 299.861L796.482 301.069C793.016 309.974 789.997 317.733 787.444 323.905C784.716 330.503 782.704 334.826 781.387 336.827C775.112 346.363 761.477 363.516 741.412 373.574C721.684 383.461 695.308 386.737 662.455 368.041C656.013 364.376 643.134 355.665 626.407 344.158C621.907 341.063 617.143 337.775 612.173 334.345C598.786 325.107 583.902 314.835 568.664 304.514C547.767 290.358 526.137 276.062 506.671 264.131C487.291 252.252 469.766 242.535 457.17 237.711C383.498 209.496 319.479 243.946 276.811 279.789C255.4 297.775 239.071 316.34 229.206 328.115C227.211 330.496 225.534 332.533 224.147 334.218Z",
    fill: "#F0B52F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2121_2977",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 489,
    height: 600
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H489V600H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2121_2977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429 260.501C468.112 545.311 166.991 789.354 -59.6191 917.353L-166 -1404.21L-119.356 -1406.35C-119.356 -1406.35 47.6795 -1347.53 121.597 -1156.25C213.994 -917.139 160.721 -622.243 121.597 -441.999C82.4729 -261.756 380.11 -95.5123 429 260.501Z",
    fill: "#185D63"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M319.055 308.036C322.343 286.19 342.717 271.146 364.562 274.433L672.268 320.734C694.113 324.021 709.158 344.395 705.871 366.24L659.57 673.946C656.283 695.792 635.909 710.836 614.064 707.549L306.358 661.248C284.512 657.961 269.468 637.587 272.755 615.742L319.055 308.036Z",
    fill: "url(#paint1_linear_2121_2977)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2121_2977",
    x1: 773.66,
    y1: 434.281,
    x2: 849.339,
    y2: 542.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0392BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2121_2977",
    x1: 489,
    y1: 491,
    x2: 548,
    y2: 575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0392BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121_2977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e9164bfb6290eaed472a6a25f6701cbb.svg";
export { ForwardRef as ReactComponent };